export default "__VITE_ASSET__BhM$Wlo7__"